import React from 'react'
import styles from './Step3.scss'
import base from 'lib/styleguide/base.scss'
import {S2DLayout} from '../../../S2DLayout'
import {FancyCheckmark} from 'common/FancyCheckmark'
import {CircleSpinner} from 'common/spinners'
import {Icon} from 'common/Icon'
import cx from 'classnames'

import iosFirstInstallMp4 from 'assets/images/send_to_device/ios_first_install.mp4'
import iosFirstInstallWebm from 'assets/images/send_to_device/ios_first_install.webm'

import androidFirstInstallMp4 from 'assets/images/send_to_device/android_first_install.mp4'
import androidFirstInstallWebm from 'assets/images/send_to_device/android_first_install.webm'

import androidDlPromptMp4 from 'assets/images/send_to_device/android_dl_prompt.mp4'
import androidDlPromptWebm from 'assets/images/send_to_device/android_dl_prompt.webm'

import iphonePushNotificationMp4 from 'assets/images/send_to_device/ios_push_notification.mp4'
import iphonePushNotificationWebm from 'assets/images/send_to_device/ios_push_notification.webm'

export class Step3 extends React.PureComponent {
  constructor (props) {
    super(props)
    // don't animate the checkmark in if the push was sent on mount
    this.state = {
      noAnimate: props.pushSent
    }
  }

  componentDidMount () {
    // start a push if the push hasn't been sent yet
    const {pushSent, pushPending, onSendPush} = this.props
    if (!(pushSent || pushPending)) {
      onSendPush()
    }
  }

  onSendPush = () => {
    this.setState({noAnimate: false})
    this.props.onSendPush()
  }

  render () {
    const {
      title,
      subtitle,
      step,
      onNext,
      onPrev,
      pushSent,
      pushPending,
      pushError,
      appInstalled,
      selectedDevice,
      stepCount
    } = this.props

    const {noAnimate} = this.state

    const StepToDisplay = appInstalled ? Step3b : Step3a
    return (
      <S2DLayout
        title={title}
        subtitle={subtitle}
        step={step}
        onClickNext={onNext}
        onClickPrev={onPrev}
        stepCount={stepCount}>
        <StepToDisplay selectedDevice={selectedDevice}>
          {pushPending && <div className={styles.status}>
            <CircleSpinner size={40} className={styles.spinner} />
            <h3>Sending route</h3>
          </div>}
          {pushSent && <div className={styles.status}>
            <FancyCheckmark noAnimate={noAnimate} />
            <h3>Route sent! </h3>
            <div><a onClick={this.onSendPush}>Click here to re-send</a></div>
          </div>}
          {pushError && <div className={cx(styles.status, base.errorMessage)}>
            <h3>Push error</h3>
            <div>
              Send to Device requires that you sign into the Ride with GPS app. Please ensure you are logged in to the app to receive your route.
            </div>
          </div>}
        </StepToDisplay>
      </S2DLayout>
    )
  }
}

const Step3a = ({children, selectedDevice}) => {
  const webm = selectedDevice === 'iphone'
    ? iosFirstInstallWebm
    : androidFirstInstallWebm

  const mp4 = selectedDevice === 'iphone'
    ? iosFirstInstallMp4
    : androidFirstInstallMp4

  return (
    <div className={styles.step3a}>
      <div className={styles.col}>
        <video width='240' height='426' autoPlay muted loop key='step3'>
          <source src={webm} type='video/webm' />
          <source src={mp4} type='video/mp4' />
        </video>
      </div>
      <div className={styles.col}>
        <h3>Open the Ride with GPS app and sign in to your account.</h3>
        <h3>Once you're logged in, go to <strong>Routes</strong> and tap <strong>Pinned</strong> to see your route.</h3>
        {children}
      </div>
    </div>
  )
}

const Step3b = ({children, selectedDevice}) => {
  const offlineHelp = selectedDevice === 'iphone'
    ? 'https://ridewithgps.com/help/offline-maps-iphone'
    : 'https://ridewithgps.com/help/offline-maps-android'

  const webm = selectedDevice === 'iphone'
    ? iphonePushNotificationWebm
    : androidDlPromptWebm

  const mp4 = selectedDevice === 'iphone'
    ? iphonePushNotificationMp4
    : androidDlPromptMp4
  return (
    <div className={styles.step3b}>
      <div className={styles.col}>
        <video width='240' height='426' autoPlay muted loop key='step3'>
          <source src={webm} type='video/webm' />
          <source src={mp4} type='video/mp4' />
        </video>
      </div>
      <div className={styles.col}>
        <h3>Tap the notification on your phone to open the route.</h3>
        <h3>
          You will be prompted to View or <strong>Download</strong>
          {' '}<a data-tip title='Download allows you to view maps and navigate routes when your phone does not have an internet connection' target='_blank' href={offlineHelp} className={styles.helpIcon}><Icon i='help-circled' /></a>
          {' '}your route.
        </h3>
        {children}
      </div>
    </div>
  )
}
